'use client';

import isAbsolutePositioning from './isAbsolutePositioning.js';
import isBodyElement from './isBodyElement.js';
import isDocumentElement from './isDocumentElement.js';
import isOverflowSet from './isOverflowSet.js';

var getScrollableParents = function (element, containers) {
    if (containers === void 0) { containers = new Set(); }
    if (isDocumentElement(element) || isBodyElement(element)) {
        containers.add(window);
    }
    else {
        var computedStyle = window.getComputedStyle(element);
        if (isOverflowSet(computedStyle.overflow) ||
            isOverflowSet(computedStyle.overflowX) ||
            isOverflowSet(computedStyle.overflowY)) {
            if (!isAbsolutePositioning(element)) {
                containers.add(element);
            }
        }
    }
    if (element.parentNode) {
        getScrollableParents(element.parentNode, containers);
    }
    return containers;
};

export { getScrollableParents as default };
//# sourceMappingURL=getScrollableParents.js.map
